import { invert } from 'lodash';

import { ENV } from '@sitegen/common/constants/environments';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';

export enum UBISOFT_CONNECT_PLATFORM_TYPES {
    UPLAY = 'uplay',
    XBL = 'xbl',
    PSN = 'psn',
    SWITCH = 'switch',
    WEB = 'web',
    MOBILE = 'mobile',
    IOS = 'ios',
    ANDROID = 'android',
    OCULUSVR = 'oculusvr',
    STEAMVR = 'steamvr',
    STADIA = 'googlestream',
    EPIC = 'epic'
}

export const PLATFORMS_TO_UBISOFT_PROFILE_PLATFORMS = {
    [PLATFORM_TYPES.PC]: UBISOFT_CONNECT_PLATFORM_TYPES.UPLAY,
    [PLATFORM_TYPES.XONE]: UBISOFT_CONNECT_PLATFORM_TYPES.XBL,
    [PLATFORM_TYPES.PS4]: UBISOFT_CONNECT_PLATFORM_TYPES.PSN,
    [PLATFORM_TYPES.SWITCH]: UBISOFT_CONNECT_PLATFORM_TYPES.SWITCH,
    [PLATFORM_TYPES.STADIA]: UBISOFT_CONNECT_PLATFORM_TYPES.STADIA,
    [PLATFORM_TYPES.XSX]: UBISOFT_CONNECT_PLATFORM_TYPES.XBL,
    [PLATFORM_TYPES.PS5]: UBISOFT_CONNECT_PLATFORM_TYPES.PSN,
};

export const UBISOFT_PROFILE_PLATFORMS_TO_PLATFORMS = invert(PLATFORMS_TO_UBISOFT_PROFILE_PLATFORMS);

export const PLATFORM_TO_EXTERNAL_LOGIN_OPTION = {
    [PLATFORM_TYPES.PC]: 'login',
    [PLATFORM_TYPES.XONE]: 'xbox-external',
    [PLATFORM_TYPES.XSX]: 'xbox-external',
    [PLATFORM_TYPES.PS4]: 'psn-external',
    [PLATFORM_TYPES.PS5]: 'psn-external'
};

export type externalLoginOptionType = 'login' | 'xbox' | 'psn' | 'twitch';

export const EXTERNAL_LOGIN_OPTIONS = {
    UBISOFT: 'login',
    XBOX: 'xbox-external',
    PSN: 'psn-external',
    TWITCH: 'twitch-external'
};

export const APPLICATION_ID_PARAM_NAME = 'applicationId';
export const GENOME_ID_PARAM_NAME = 'genomeId';
export const UBICONNECT_LOGGED_IN = 'UBICONNECT_LOGGED_IN';

export const CONNECT_LOGIN_LOCATION = {
    [ENV.DEV]: 'https://uat-connect.ubisoft.com',
    [ENV.PROD]: 'https://connect.ubisoft.com'
};

export const CONNECT_SDK_LOCATION = {
    [ENV.DEV]: 'https://ubistatic2-a.akamaihd.net/uplay-connect/v3/uat/default/sdk/connectSdkPublic.js',
    [ENV.PROD]: 'https://ubistatic2-a.akamaihd.net/uplay-connect/v3/prod/default/sdk/connectSdkPublic.js'
};

export const AUTH_URL = 'auth-url.html';
export const NEXT_URL_POPUP_INIT = 'callback.html';
export const NEXT_URL_TPC_CALLBACK = 'tpc_disabled_callback.html';
